import React from 'react';
import '../styles/UpdatePrompt.css';

interface UpdatePromptProps {
  show: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
  isUpdating?: boolean;
}

const UpdatePrompt: React.FC<UpdatePromptProps> = ({ 
  show, 
  onUpdate, 
  onDismiss, 
  isUpdating = false 
}) => {
  if (!show) return null;

  return (
    <div className="update-prompt-overlay">
      <div className="update-prompt">
        <div className="update-prompt-header">
          <h3>🍌 Update Available!</h3>
        </div>
        <div className="update-prompt-body">
          <p>
            A new version of Banana Cup is available. 
            Update now to get the latest features and improvements.
          </p>
        </div>
        <div className="update-prompt-actions">
          <button 
            className="update-prompt-btn update-prompt-btn-secondary"
            onClick={onDismiss}
            disabled={isUpdating}
          >
            Later
          </button>
          <button 
            className="update-prompt-btn update-prompt-btn-primary"
            onClick={onUpdate}
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Update Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;
